import { createContext } from "react";
import type { Services } from "@/lib/services";

export const ServicesContext = createContext<Services | null>(null);
